
// Force pagination mode - disable infinite scroll
// This script runs BEFORE the paginated-list Web Component initializes

(function() {
  // Patch 1: Override the results-list attribute BEFORE it's read
  // Remove infinite-scroll attribute from results-list elements
  function patchResultsList() {
    document.querySelectorAll('results-list').forEach(el => {
      el.removeAttribute('infinite-scroll');
      el.setAttribute('infinite-scroll', '');  // empty string = falsy in most checks
    });
    
    // Remove the sentinel spans that trigger infinite scroll
    document.querySelectorAll('[ref="viewMoreNext"], [ref="viewMorePrevious"]').forEach(el => {
      el.remove();
    });
    
    // Make sure pagination controls are visible
    document.querySelectorAll('pagination-controls').forEach(el => {
      el.removeAttribute('hidden');
      el.style.display = '';
    });
  }
  
  // Patch 2: Override customElements to intercept paginated-list registration
  // and neutralize the infinite scroll behavior
  const originalDefine = customElements.define.bind(customElements);
  customElements.define = function(name, constructor, options) {
    if (name === 'paginated-list' || name === 'results-list') {
      // Wrap the connectedCallback to remove infinite scroll behavior
      const origConnected = constructor.prototype.connectedCallback;
      if (origConnected) {
        constructor.prototype.connectedCallback = function() {
          // Remove the infinite-scroll attribute before the component reads it
          this.removeAttribute('infinite-scroll');
          // Remove sentinel spans
          const next = this.querySelector('[ref="viewMoreNext"]');
          const prev = this.querySelector('[ref="viewMorePrevious"]');
          if (next) next.remove();
          if (prev) prev.remove();
          
          if (origConnected) origConnected.call(this);
          
          // After initialization, disconnect any observers
          if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
          }
          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }
        };
      }
    }
    return originalDefine(name, constructor, options);
  };
  
  // Patch 3: Run DOM cleanup at multiple points
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchResultsList);
  } else {
    patchResultsList();
  }
  
  // MutationObserver to catch dynamically added elements
  const mo = new MutationObserver(() => {
    const spans = document.querySelectorAll('[ref="viewMoreNext"], [ref="viewMorePrevious"]');
    if (spans.length) {
      spans.forEach(el => el.remove());
    }
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    mo.observe(document.body, { childList: true, subtree: true });
    patchResultsList();
    // Also remove after delays
    setTimeout(patchResultsList, 300);
    setTimeout(patchResultsList, 1000);
    setTimeout(patchResultsList, 2500);
    
    // Stop observing after 5 seconds
    setTimeout(() => mo.disconnect(), 5000);
  });
})();
